
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.395 11.075a.423.423 0 000 .844h4.253l-.06.063-1.218 1.3a.441.441 0 000 .6.384.384 0 00.28.125.379.379 0 00.279-.124l1.953-2.079a.424.424 0 00.093-.156.445.445 0 00.024-.144.472.472 0 00-.031-.161.42.42 0 00-.086-.138l-1.953-2.081a.393.393 0 00-.56 0 .444.444 0 000 .6l1.278 1.36z"}}),_c('path',{attrs:{"d":"M13.704 18H7.295a1.283 1.283 0 01-1.3-1.265V6.265a1.283 1.283 0 011.3-1.264h6.411a1.3 1.3 0 01.91.362 1.243 1.243 0 01.381.9v.818a.453.453 0 01-.458.447.46.46 0 01-.463-.446v-.819a.377.377 0 00-.382-.372h-6.4a.377.377 0 00-.382.372v10.47a.378.378 0 00.382.372h6.4a.378.378 0 00.382-.372v-.819a.46.46 0 01.463-.445.452.452 0 01.458.445v.819a1.242 1.242 0 01-.381.9 1.3 1.3 0 01-.912.367z"}})])
          )
        }
      }
    